export const STATE_KEY = 'OAuthRegistrationForm'
export const FORM_NAME = 'o_auth_registration'

export const CONTENT_LOAD = 'Casino/OAuthRegistrationForm/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/OAuthRegistrationForm/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/OAuthRegistrationForm/LOAD_ERROR'
